import Login from '@/pages/Login'
import Dashboard from '@/pages/Dashboard'
import Recordings from '@/pages/Recordings'
import Profile from '@/pages/Profile'
import PasswordReset from '@/pages/PasswordReset'
import ForgottenPassword from '@/pages/ForgottenPassword'
import PasswordChange from '@/pages/PasswordChange'
import CompanySetup from '@/pages/CompanySetup'

import adminRoutes from './Admin/routes'
import reportsRouters from './Reports/routes'

export default adminRoutes.concat(reportsRouters, [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'titles.login',
      unauthorizedOnly: true
    }
  },
  {
    path: '/forgotten-password',
    name: 'ForgottenPassword',
    component: ForgottenPassword,
    meta: {
      requiresAuth: false,
      unauthorizedOnly: true,
      title: 'titles.forgottenPassword'
    },
    props: true
  },
  {
    path: '/password-reset/:token',
    name: 'PasswordReset',
    component: PasswordReset,
    meta: {
      requiresAuth: false,
      unauthorizedOnly: true,
      title: 'titles.passwordReset'
    },
    props: true
  },
  {
    path: '/password-change',
    name: 'PasswordChange',
    component: PasswordChange,
    meta: {
      requiresAuth: false,
      title: 'titles.passwordReset'
    }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Login,
    props: { logout: true }
  },
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      title: 'titles.dashboard',
      requiresAuth: true,
      roles: [ 'SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN', 'COMPANY_USER' ]
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      title: 'titles.profile',
      requiresAuth: true
    }
  },
  {
    path: '/recordings',
    name: 'Recordings',
    component: Recordings,
    meta: {
      title: 'titles.recordings',
      requiresAuth: true,
      roles: [ 'COMPANY_ADMIN', 'COMPANY_USER' ],
      ignoreDelegations: true
    }
  },
  {
    path: '/company-setup',
    name: 'CompanySetup',
    component: CompanySetup,
    meta: {
      title: 'titles.companySetup',
      requiresAuth: false
    }
  }
])



// WEBPACK FOOTER //
// ./src/pages/routes.js